import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension" as const;

export const postDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionCacheKeys: AllRouteEndpoints[] =
  [
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension,
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions,
  ];
